import { render, staticRenderFns } from "./WritingsOnErrorTable.vue?vue&type=template&id=20835ef1&"
import script from "./WritingsOnErrorTable.vue?vue&type=script&lang=js&"
export * from "./WritingsOnErrorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports